
    const data = {"name":"src/core/icons/calendar-account","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M12 9c2 0 3 2.42 1.59 3.84-1.42 1.42-3.84.41-3.84-1.59C9.75 10 10.75 9 12 9m4.5 9h-9v-1.12c0-1.25 2-2.25 4.5-2.25s4.5 1 4.5 2.25M19 19H5V8h14m-3-7v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2h-1V1h-2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            